<div class="row">
  <div class="col-4" *ngIf="title != null"><label>{{title}}</label></div>
  <div [class.col-8]="title != null" [class.col-12]="title == null">
    <div class="form-group" *ngIf="customerService!=null">
      <ng2-completer
        [(ngModel)]="businessName"
        [datasource]="customerService"
        [minSearchLength]="0"
        (selected)="select($event)"
        [disabled]="!enabled"
        inputClass="form-control form-control-sm"
      >

      </ng2-completer>
    </div>
  </div>
</div>
